import GridComponent from '../../../../component/grid/GridComponent.component';
import Notification from '../../interfaces/Notification';
import { useFormik } from 'formik';
import { FormInterface } from '../../../../core/interfaces/form/Form';
import ButtonForm from '../../../../component/buttton/ButtonForm.component';
import { Form } from '../../../../component/form/Form';
import FormHeader from '../../form/FormHeader.component';
import FormSolved from '../../form/FormSolved.component';

export default function FormComponent({ handleSubmitForm, initialValues, disabled }: FormInterface<Notification>) {

    const { handleSubmit, handleChange, values, setFieldValue } = useFormik<Notification>({
        initialValues: initialValues,
        onSubmit: values => {
            handleSubmitForm(values);
        },
    });

    return (
        <Form onSubmit={handleSubmit}>
            <GridComponent justify="flex-start" alignItems="center" spacing={2} >
                <FormHeader handleChange={handleChange} initialValues={values} setFieldValue={setFieldValue} disabled={true} />

                <FormSolved handleChange={handleChange} initialValues={values} disabled={disabled} setFieldValue={setFieldValue} />

                <ButtonForm link="/notificacao" title="Encerrar" />

            </GridComponent>
        </Form>
    )
}